import React, { useEffect, useState, useContext } from 'react';
import CardFeatures from './CardFeatures';

import TabContent from '../Bootstrap/Tabs/TabContent';
import TabNavigation from '../Bootstrap/Tabs/TabNavigation';

import { useTranslation } from 'react-i18next';

import MapContext from '../Map/MapContext';

import Modal from '../Bootstrap/Modal/Modal';

const ModalWithTabs = ({ features, setFeatures, onStartGeometryEdit }) => {
  const [featuresForCat, setFeaturesForCat] = useState({});
  const [tabs, setTabs] = useState([]);
  const [contents, setContents] = useState([]);
  const [activeTab, setActiveTab] = useState('');
  const [currentIndexes, setCurrentIndexes] = useState({});
  const [showModal, setShowModal] = useState(false);

  const { t } = useTranslation();
  const { map } = useContext(MapContext);

  const handleCloseModal = () => {
    setShowModal(false)
    setFeatures([]); // Limpiar los features al cerrar el modal
    setFeaturesForCat({}); // Limpiar los features por categoría
    changeCursor('help'); // Cambiar el cursor a su estado original
  };

  const goToNext = (tab) => {
    const activeFeatures = featuresForCat[tab] || [];
    setCurrentIndexes((prevIndexes) => ({
      ...prevIndexes,
      [tab]: (prevIndexes[tab] + 1) % activeFeatures.length,
    }));
  };

  const goToPrevious = (tab) => {
    const activeFeatures = featuresForCat[tab] || [];
    setCurrentIndexes((prevIndexes) => ({
      ...prevIndexes,
      [tab]: (prevIndexes[tab] - 1 + activeFeatures.length) % activeFeatures.length,
    }));
  };


  function changeCursor(cursor = '') {
    if (!map) return;
    const mapElement = map.getTargetElement();
    if (mapElement) mapElement.style.cursor = cursor;
  }

  useEffect(() => {
    if (features) {
      const objetFeaturesForCat = {};

      features.forEach((item) => {
        Object.keys(item).forEach((key) => {
          // Si la categoría ya existe, combinar los arrays en lugar de sobrescribir
          if (objetFeaturesForCat[key]) {
            // Combinar arrays
            const existingFeatures = Array.isArray(objetFeaturesForCat[key]) 
              ? objetFeaturesForCat[key] 
              : [objetFeaturesForCat[key]];
            const newFeatures = Array.isArray(item[key]) 
              ? item[key] 
              : [item[key]];
            objetFeaturesForCat[key] = [...existingFeatures, ...newFeatures];
          } else {
            // Primera vez que se encuentra esta categoría
            objetFeaturesForCat[key] = item[key];
          }
        });
      });

      setFeaturesForCat(objetFeaturesForCat);

      // Inicializar/resetear los índices de TODAS las categorías presentes en los features
      const resetIndexes = Object.keys(objetFeaturesForCat).reduce((acc, key) => {
        acc[key] = 0;
        return acc;
      }, {});

      // Actualizar currentIndexes con los valores reiniciados
      setCurrentIndexes(resetIndexes);
    } 

  }, [features]);

  useEffect(() => {
    if (featuresForCat) {
      const newTabs = Object.keys(featuresForCat).map((key) => ({
        // label: t(`Categoria ${key}`),
        label: t(key),
        value: key,
        icon: 'bi-layers-fill', // Icono de capa sólido para las pestañas de categorías
      }));

      const newContents = Object.entries(featuresForCat).map(([key, value]) => ({
        value: key,
        component: (
          <CardFeatures
            features={value}
            currentIndex={currentIndexes[key] || 0}
            goToNext={() => goToNext(key)}
            goToPrevious={() => goToPrevious(key)}
            onStartGeometryEdit={onStartGeometryEdit}
            onCloseModal={handleCloseModal}
          />
        ),
      }));

      if (!activeTab && newTabs.length > 0) {
        setActiveTab(newTabs[0].value); // Selecciona el primer tab
      }

      setTabs(newTabs);
      setContents(newContents);
      changeCursor();
      setShowModal(true);
    }
  }, [featuresForCat, currentIndexes]);

  useEffect(() => {
    if (activeTab && !(activeTab in currentIndexes)) {
      setCurrentIndexes((prevIndexes) => ({
        ...prevIndexes,
        [activeTab]: 0, // Inicializa a 0 solo si no existe
      }));
    }
  }, [activeTab]);

  return (
    <Modal
      show={showModal}
      onClose={handleCloseModal}
      title={t('Info')}
      footer={
        features.length > 0 && (
          <div className="d-flex justify-content-center align-items-center mt-2 gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => goToPrevious(activeTab)} // Usa activeTab
            >
              &lt;
            </button>
            <span className="fw-bold">
              {`${(currentIndexes[activeTab] || 0) + 1} ${t('of')} ${featuresForCat[activeTab]?.length || 0}`}
            </span>
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => goToNext(activeTab)} // Usa activeTab
            >
              &gt;
            </button>
          </div>
        )
      }

    >
      <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />
      <TabContent activeTab={activeTab} contents={contents} />
    </Modal>
  );
};

export default ModalWithTabs;